<template>
  <v-container :fluid="true" class="bg-light-beige ma-0 pa-0">
    <RegistrationUser v-if="$route.name === names.CREATE_USER.PAGE"/>
    <router-view v-else />
  </v-container>
</template>

<script>
import { defineComponent } from 'vue'
import RegistrationUser from "@/modules/core/components/registration/RegistrationUser.vue"
import names from "@/modules/core/routers/names"
import pa_names from "@/modules/personal_account/routers/names"
import { mapGetters } from "vuex"

export default defineComponent({
  name: "CreateUser",
  computed: {
    names () {
      return names
    },
    pa_names () {
      return pa_names
    },
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      getUserStatus: 'auth/getUserStatus',
    })
  },
  components: { RegistrationUser },
  created () {
    if (this.isAuthenticated) {
      this.$router.push({ name: pa_names.MAIN })
    }
  }
})
</script>

<style scoped lang="scss">

</style>
